export default "__VITE_ASSET__6d426075__"